import { flowRight as compose } from 'lodash';
import queries from '~lib/common/queries/EffectChain';
import renameProps from '~lib/common/hoc/renameProps';

import dataView from '~lib/common/hoc/dataView';

import EffectChainEditor from './EffectChainEditor.vue';

const enhance = compose(
  dataView({
    queries: {
      fetchById: queries.fetchById,
    },
  }),
  renameProps({ itemData: 'baseEffectChain' }),
);

export default enhance(EffectChainEditor);
